import {IPromoCodeService} from "@/services/promo-code/promo-code.model";
import axios, {AxiosInstance, AxiosResponse} from "axios";
import {defaultConfig} from "@/services/config";
import {
  ICertItemFilterData,
  IListResponse,
  IPromoCodeData,
  IRequestExtended,
  IRequestPromoCodeHistoryData
} from "@/entities";

export class PromoCodeService implements IPromoCodeService {
  constructor(private readonly axios: AxiosInstance) {}

  async getAllPromoCodes(data?: IRequestExtended<ICertItemFilterData>, language?: string): Promise<AxiosResponse<IListResponse<IPromoCodeData[]>>> {
    let config = data?.config;
    if (config) {
      let api = axios.create(config);
      return api({
        ...defaultConfig(language),
        ...config
      });
    } else {
      return this.axios.get('/promo_code/', {
        ...defaultConfig(language),
        params: data?.payload
      })
    }
  }
  async getRequestPromoCodeHistories(data: IRequestExtended): Promise<AxiosResponse<IListResponse<IRequestPromoCodeHistoryData[]>>> {
    return this.axios.get(`/request_promo_code/${ data.key }/history/`, {
      ...defaultConfig(),
      ...data.config
    })
  }
}
